<template>

  <div :class="showBackground ? 'edit-pane' : ''">
      <el-row>
        <el-col :xs="24" :sm="24" :md="20" :lg="20">
          <span v-if="deletable  && !adding">
            <el-button :type="deleteButtonType" size="mini" @click="deleted"
             icon="fa fa-trash-alt"
             :round="deleteButtonType === 'text' ? false : round"
             :disabled="this.isViewOnly()">
              <span v-if="showButtonText" class="hidden-md-and-down"> Delete</span>
            </el-button>&nbsp;&nbsp;
          </span>
          <span v-if="title">
            <span v-if="!titleHeading"><span class="text-info">{{prefix}}:&nbsp;</span><span class="text-primary" v-html="title"></span></span>
            <span :is="titleHeading" v-else><span v-if="prefix">{{prefix}}:&nbsp;</span>{{title}}</span>
          </span>
          <span v-else>
            &nbsp;
          </span>
        </el-col>

        <el-col v-if="adding || showEditButton" :class="isMediumOrLess ? 'text-center'  : 'text-right'" :span="4" >

          <div v-if="isEditMode && this.canChange()">
            <el-button type="warning" size="mini" @click="cancel" icon="fa fa-times-circle" :round="round"><span v-if="showButtonText" class="hidden-md-and-down"> Cancel</span></el-button>&nbsp;
            <el-button type="success" size="mini" @click="save" icon="fa fa-check" :round="round"><span v-if="showButtonText" class="hidden-md-and-down">Save</span></el-button>
          </div>

          <div v-else>
            <span v-if="editable && !adding">
              <el-button :type="editButtonType"
                size="mini" @click="edit"
                icon="fa fa-edit"
                :round="editButtonType === 'text' ? false : round"
                :disabled="this.isViewOnly()">
                <span v-if="showButtonText" class="hidden-md-and-down">  Edit</span>
              </el-button>


            </span>
            <span v-if="adding">
              <el-button :type="addButtonType" size="mini" @click="add" icon="fa fa-plus-circle" :round="addButtonType === 'text' ? false : round">
                <span v-if="showButtonText" class="hidden-md-and-down">  Add</span>
              </el-button>
            </span>
          </div>

          <br />
        </el-col>

      </el-row>

      <el-row align="start">
        <el-col :span="24">
          <slot />
        </el-col>
      </el-row>

    </div>
</template>

<script>

export default {
  name: 'edit-pane',

  props: {
    prefix: {
      type: String,
      default: null
    },

    title: {
      type: String,
      default: ''
    },

    showTitle: {
      type: Boolean,
      default: true
    },

    titleHeading: {
      type: String,
      default: null
    },

    editable: {
      type: Boolean,
      default: true
    },

    deletable: {
      type: Boolean,
      default: false
    },

    isEdit: {
      type: Boolean,
      default: false
    },

    showButtonText: {
      type: Boolean,
      default: true
    },

    adding: {
      type: Boolean,
      default: false
    },

    round: {
      type: Boolean,
      default: true
    },

    addButtonType: {
      type: String,
      default: 'primary'
    },

    editButtonType: {
      type: String,
      default: 'info'
    },

    deleteButtonType: {
      type: String,
      default: 'danger'
    },

    showEditButton: {
      type: Boolean,
      default: true
    },

    showBackground: {
      type: Boolean,
      default: true
    },

    parentManaged: {
      type: Boolean,
      default: false
    }

  },

  computed: {
    isEditMode () {
      return this.parentManaged ? this.isEdit : this.editModeState
    },

    disable () {
      var disabled = (!this.editable && !this.isEditMode) || !this.isAdding()
      return this.isViewOnly() || disabled
    }
  },

  methods: {
    setEditMode (val) {
      if (!this.parentManaged) {
        this.editModeState = val
      }
    },

    add () {
      this.setEditMode(this.adding ? this.adding : !this.editModeState)
      this.$emit('add')
    },

    edit () {
      this.setEditMode(!this.editModeState)
      this.$emit('edit')
    },

    deleted () {
      this.setEditMode(false)
      this.$emit('delete')
    },

    save () {
      this.setEditMode(false)
      this.$emit('save')
    },

    cancel () {
      this.setEditMode(false)
      this.$emit('cancel')
    },

    isEditable () {
      return this.isViewOnly() ? false : this.editable
    },

    isAdding () {
      return this.isViewOnly() ? false : this.adding
    }

  },



  data () {
    return {
      showTitleLocal: this.showTitle,
      editModeState: this.isViewOnly() ? false : (this.adding ? true : this.isEdit)
    }
  },

  mounted () {
    if (this.title === null || this.title === '') {
      this.showTitleLocal = false
    }
//    console.log(`editPane [ editMode ${this.editMode} | editable ${this.editable} | disabled ${this.disable} | adding ${this.adding} ]`)
  }

}

</script>

<style scoped>

 .edit-pane {
   background-color: #F2F6FC;
   border-radius: 8.52px;
   padding-top: 1em;
   padding-left: 2em;
   padding-right: 2em;
   margin-bottom: 1em;
 }
</style>



// WEBPACK FOOTER //
// EditPane.vue?d8333a56